import imagesStyles from "../../imagesStyles";
import { primaryColor } from "assets/jss/xrs.js";

const welcomeSectionStyle = {
  ...imagesStyles,
  white: {
    color: "white",
    fontWeight: 500,
    paddingLeft: 20,
  },
  whiteRight: {
    color: "white",
    fontWeight: 500,
    textAlign: "right",
  },
  blueTitle: {
    color: primaryColor[20],
    fontWeight: 400,
    marginBottom: 0,
  },
  RightText: {
    marginBottom: 5,
  },
  Title: {
    fontWeight: 500,
    paddingTop: 30,
  },
  tableWrapper: {
    maxHeight: 270,
    overflow: "auto",
    maxWidth: 600,
  },
  tableWrapperMobile: {
    maxHeight: 270,
    overflow: "auto",
    maxWidth: 400,
    marginTop: 10,
    marginBottom: 0,
  },
  Wellcome: {
    fontWeight: 500,
  },
  accountRow: {
    paddingRight: 15,
    marginLeft: 15,
    marginRight: -15,
    paddingTop: 3,
    paddingBottom: 3,
  },
  groupRow: {
    backgroundColor: "#D3F3F3",
    width: "100%",
    marginLeft: 30,
    marginRight: 0,
    borderBottom: "1px solid",
    borderColor: "black",
    fontWeight: 600,
    paddingLeft: 0,
  },
  totalRow: {
    paddingRight: 0,
    marginLeft: 0,
    marginRight: 15,
    fontWeight: 600,
  },
};

export default welcomeSectionStyle;
